import { AppConstant } from '../../constant/AppConstant';
import '../../assets/css/components/WhatsAppButton.css';

export function WhatsAppButton() {
  return (
    <a
      href={AppConstant.whatsApp_link}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
    >
      <i className="fa-brands fa-whatsapp"></i>
      <span className="whatsapp-tooltip">Chat with us!</span>
    </a>
  );
}